export const TIME_ALERTS = {
	TIME_REGISTRATION_START_TOO_EARLY: "Fichaje de entrada demasiado pronto",
	TIME_REGISTRATION_START_TOO_LATE: "Fichaje de entrada demasiado tarde",
	TIME_REGISTRATION_END_TOO_EARLY: "Fichaje de salida demasiado pronto",
	TIME_REGISTRATION_END_TOO_LATE: "Fichaje de salida demasiado tarde",
	TIME_REGISTRATION_NOT_DONE: "Fichaje de entrada no realizado",
	TIME_REGISTRATION_BREAK_TOO_SHORT: "Descanso demasiado corto",
	TIME_REGISTRATION_BREAK_TOO_LONG: "Descanso demasiado largo",
	TIME_REGISTRATION_BREAK_NOT_PLANNED: "Descanso no planificado",
	TIME_REGISTRATION_PAID_BREAK_TOO_LONG: "Pausa retribuida demasiado larga",
	TIME_REGISTRATION_PAID_BREAK_OCCURRENCES_MISMATCH:
		"Número de pausas retribuidas incorrecto",
	TIME_REGISTRATION_NOT_IN_UBICATION: "Fichaje fuera de ubicación",
};

export const isTimeRegistrationBreakAlert = (type) =>
	typeof type === "string" &&
	(type.startsWith("TIME_REGISTRATION_BREAK") ||
		type.startsWith("TIME_REGISTRATION_PAID_BREAK"));

export const TIME_LIST_VIEWS = {
	list: 1,
	employee_day: 2,
	employee_week: 3,
};
